import type { ReactNode } from 'react';
import { SyncConfigurationModal } from '../sync-configuration-modal/SyncConfigurationModal';
import { useSyncConfigurationStoreModal } from './SyncConfigurationStoreModal.hook';
import type { SyncConfigurationStoreModalProps } from './SyncConfigurationStoreModal.model';
import styles from './SyncConfigurationStoreModal.module.scss';
export function SyncConfigurationStoreModal({
  isOpen,
  isLoading: isLoadingSubmission,
  onSync,
  onCancel,
  storeId,
}: SyncConfigurationStoreModalProps): ReactNode {
  const { isLoading, ...dashboardRowData } = useSyncConfigurationStoreModal({ isOpen, storeId });

  return (
    <SyncConfigurationModal
      scope="store"
      isOpen={isOpen}
      isLoading={isLoading}
      isLoadingSubmission={isLoadingSubmission}
      onSync={onSync}
      onCancel={onCancel}
      devicesClassName={styles.storeDevices}
      dashboardRowData={dashboardRowData}
    />
  );
}
